import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { setBloodProductRouteOptions } from '../store/options.actions'

export function* getBloodProductRouteOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getBloodProductRouteOptions])
    const { entity } = response
    yield put(setBloodProductRouteOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getBloodProductRouteOptions() error: ${e}`))
  }
}
export function* getBloodProductRouteOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getBloodProductRouteOptions)
}
